<template>
    <block>
        <div class="page" v-if="companyId">
            <header>
                <img class="" :src="pageInfo.FaceImgUrl" />
                <div>
                    <p>{{pageInfo.AccountName}}</p>
                    <span v-if="pageInfo.IsMember">{{pageInfo.MemberCategoryName}}<i v-if="pageInfo.MemberEndTime">到期日期：{{pageInfo.MemberEndTime}}</i></span>
                    <span v-else>{{pageInfo.MemberDesc}}</span>
                </div>
            </header>
            <main>
                <h4>VIP会员</h4>
                <ul class="price-block">
                    <li :class="vipActive === 0 ? 'active' :''" @click="clickVipActive(0)">
                        <span v-if="pageInfo.PriceList[0].IsContinuousPay">限时优惠</span>
                        <p>{{ pageInfo.PriceList[0].SetMealTypeName }}</p>
                        <p class="price">￥{{ pageInfo.PriceList[0].RealAmount }}</p>
                        <p class="old-price">￥{{ pageInfo.PriceList[0].OriginalAmount }}</p>
                    </li>
                    <li :class="vipActive === 1 ? 'active' :''" @click="clickVipActive(1)">
                        <span v-if="pageInfo.PriceList[1].IsContinuousPay">限时优惠</span>
                        <p>{{ pageInfo.PriceList[1].SetMealTypeName }}</p>
                        <p class="price">￥{{ pageInfo.PriceList[1].RealAmount }}</p>
                        <p class="old-price">￥{{ pageInfo.PriceList[1].OriginalAmount }}</p>
                    </li>
                </ul>
                <h4><img src="../../assets/center/vip/icon-tequan.png" alt=""/>会员权益</h4>
                <div class="vip-block">
                    <ul>
                        <li v-for="(item, index) in pageInfo.VipEquityList" :key="index">
                            <img class="" :src="item.BgImgUrl" />
                            <p>{{item.MainTitle}}</p>
                        </li>
                    </ul>
                </div>
                <div class="protocal-block">
                    <el-checkbox v-model="agreeProtocal"></el-checkbox>
                    <div class="protocal-text" @click="showProtocalDialog">{{chooseItem.IsContinuousPay ? '开通前请阅读《自动续费服务协议》' : '开通前请阅读《会员服务协议》'}} <i class="el-icon-arrow-right"></i></div>
                </div>
                <button @click="payBtn" :disabled="!agreeProtocal">{{ pageInfo.OpenMemberBtnTxt }}</button>
            </main>
        </div>

        <div class="page" v-if="userId">
            <header :class="'level-bg'+(activeLevel+1)">
                <img class="" :src="pageInfo.FaceImgUrl" />
                <div>
                    <p>{{pageInfo.AccountName}}</p>
                    <span v-if="pageInfo.IsMember">{{pageInfo.MemberCategoryName}}<i v-if="pageInfo.MemberEndTime">到期日期：{{pageInfo.MemberEndTime}}</i></span>
                    <span v-else>{{pageInfo.MemberDesc}}</span>
                </div>
            </header>
            <main>
                <h4>
                    <span v-for="(item, index) in memberLevel" :key="index" :class="activeLevel === index ? 'active' :'mini-text'" @click="clickActiveLevel(index)">{{ item.label }}</span>
                </h4>
                <ul class="price-block">
                    <li v-for="(item, index) in memberLevel[activeLevel].list" :key="index" :class="vipActive === index ? 'active' :''" @click="clickVipActive(index)">
                        <span v-if="item.IsContinuousPay">限时优惠</span>
                        <p>{{ item.SetMealTypeName }}</p>
                        <p class="price">￥{{ item.RealAmount }}</p>
                        <p class="old-price">￥{{ item.OriginalAmount }}</p>
                    </li> 
                </ul>
                <h4><img src="../../assets/center/vip/icon-tequan.png" alt=""/>会员权益对比</h4>
                <div class="equity-block">
                    <ul>
                        <li v-for="(itemP, indexP) in memberEquity" :key="indexP" :class="['equity' + indexP, 'l' + activeLevel + 'e' +indexP]">
                            <i class="level-icon" v-if="indexP === 0" />
                            <img class="level-icon" v-if="indexP === 1" src="../../assets/h5/level-icon3.png" alt=""/>
                            <img class="level-icon" v-if="indexP === 2" src="../../assets/h5/level-icon2.png" alt=""/>
                            <img class="level-icon" v-if="indexP === 3" src="../../assets/h5/level-icon1.png" alt=""/>
                            <div v-for="(item, index) in itemP" :key="index">
                                <img v-if="item.indexOf('.png') !== -1" :src="item" />
                                <p v-else>{{item}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="protocal-block">
                    <el-checkbox v-model="agreeProtocal"></el-checkbox>
                    <div class="protocal-text" @click="showProtocalDialog">{{chooseItem.IsContinuousPay ? '开通前请阅读《自动续费服务协议》' : '开通前请阅读《会员服务协议》'}} <i class="el-icon-arrow-right"></i></div>
                </div>
                <button @click="payBtn" :disabled="!agreeProtocal">{{ pageInfo.OpenMemberBtnTxt }}</button>
            </main>
        </div>
        <el-drawer
            :visible.sync="showIframe"
            direction="btt"
            size="85%">
            <iframe src="https://m.insupai.com/html/protocal/protocol_220121_vipRenew.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
        </el-drawer>
        <el-drawer
            :visible.sync="showIframe2"
            direction="btt"
            size="85%">
            <iframe src="https://m.insupai.com/html/protocal/protocol_220121_vipService.html" frameborder="0" style="width: 100%;height: 100%;"></iframe>
        </el-drawer>
        

    </block>
      
</template>
<script>
import {   GetMemberCenterInfo } from '@/scripts/api.js'
import { mapState } from "vuex";

export default({
    data() {
       return {
        userId: '',
        companyId: '',
        pageInfo: {},
        vipActive: 0,
        memberLevel: [],
        activeLevel: 0,
        memberEquity: [["会员等级"],["黄金会员"],["铂金会员"],["钻石会员"]],
        protocalDialog: false,
        showIframe: null,
        showIframe2: null,
        agreeProtocal: false
       } 
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo,
        }),
        chooseItem() {
            let chooseItem  = {}
            if(this.companyId) {
                chooseItem  = this.pageInfo.PriceList[this.vipActive];
            }else {
                chooseItem = this.memberLevel[this.activeLevel].list[this.vipActive]
            }
            return chooseItem;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let params = {};
            if (this.$route.query.userId) { // 个人会员
                params.userId = this.$route.query.userId;
                this.userId = this.$route.query.userId;
                this.windowToUMRecord('20112');
            }else { // 企业会员
                params.companyId = this.$route.query.companyId;
                this.companyId = this.$route.query.companyId;
                this.windowToUMRecord('20107');
            }
            GetMemberCenterInfo(params).then(r => {
                if (r.Result == 1) {
                    this.pageInfo = r.Data;
                    if(this.userId) {
                        this.memberLevel = [{
                            label: '钻石会员',
                            list: this.pageInfo.PriceList.filter(item=>item.MemberCategoryName === "钻石会员")
                        },{
                            label: '铂金会员',
                            list: this.pageInfo.PriceList.filter(item=>item.MemberCategoryName === "铂金会员")
                        },{
                            label: '黄金会员',
                            list: this.pageInfo.PriceList.filter(item=>item.MemberCategoryName === "黄金会员")
                        }]
                        this.pageInfo.UserEngineerEquityList.map(item=>{
                            this.memberEquity[0].push(item.Title || "无");
                            this.memberEquity[1].push(item.GoldEquity || "无");
                            this.memberEquity[2].push(item.PlatinumEquity || "无");
                            this.memberEquity[3].push(item.DiamondEquity || "无");
                        })
                    }
                }else{
                    this.$toast(r.Message);
                }
            })
        },
        clickActiveLevel(index) {
            this.activeLevel = index;
            this.clickRecordBtn();
        },
        clickVipActive(index) {
            this.vipActive = index;
            this.clickRecordBtn();
        },
        payBtn() {
            let chooseStr = JSON.stringify(this.chooseItem)
            this.windowTo(chooseStr);
            if (this.$route.query.userId) { // 个人会员
                this.windowToUMRecord('20120');
            }else {
                this.windowToUMRecord('20111');
            }
        },
        windowTo(chooseStr) {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android
            var isPhone = /mobile/i.test(u);
            if(isPhone) {
                if (isAndroid) {
                    window.App.buyVipMember(chooseStr); // 向android传参
                } else {
                    window.webkit.messageHandlers.buyVipMember.postMessage(chooseStr); // 向ios传参
                }
            }
        },
        clickRecordBtn() {
            let smId = ""+ this.chooseItem.MemberCategory + this.chooseItem.SetMealType;
            let chooseUMId = { // 友盟埋点id转换
                '31': '20113',
                '34': '20114',
                '21': '20115',
                '24': '20116',
                '11': '20117',
                '14': '20118',
                '41': '20108',
                '44': '20109'
            }[smId]
            this.windowToUMRecord(chooseUMId);
        },
        // 友盟埋点
        windowToUMRecord(id) {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android
            var isPhone = /mobile/i.test(u);
                if(isPhone) {
                if (isAndroid) {
                    window.App.addUMEvent(id); // 向android传参
                } else {
                    window.webkit.messageHandlers.addUMEvent.postMessage(id); // 向ios传参
                }
            }
        },
        showProtocalDialog() {
            if(this.chooseItem.IsContinuousPay) {
                this.showIframe = true;
                this.showIframe2 = null;
            }else {
                this.showIframe = null;
                this.showIframe2 = true;
            }
        }
    },
})
</script>
<style  lang="scss">
.page {
    background-color: #F7F7F7;
    padding-top: 16px;
    header {
        background: url(../../assets/center/vip/vip-bg2.png); 
        background-size: 100% 100%;
        height: 120px;
        display: flex;
        margin: 0 16px 16px 16px;
        font-family: PingFangSC, PingFang SC;
        img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin: 17px 10px 17px 17px;
            background: #fff;
        }
        div {
            p {
                font-size: 18px;
                color: #703B0D;
                margin-top: 17px;
                font-weight: bold;
            }
            span {
                font-size: 12px;
                color: rgba(112,59,13,0.5);
                i {
                    margin-left: 10px;
                }
            }
        }
    }
}

main {
    margin: 20px 0;
    background: #fff;
    border-radius: 10px;
    h4 {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        padding: 16px 17px;
        img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
            vertical-align: sub;
        }
        span {
            margin-right: 12px;
            position: relative;
            font-family: PingFang-SC, PingFang-SC;
        }
        span.mini-text {
            font-size: 14px;
            color: #888;
        }
        span.active::before {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 20px;
            width: 24px;
            height: 2px;
            background: #333;
        }
    }
    .price-block {
        padding: 0 17px;
        display: flex;
        gap: 13px;
        justify-content: center;
        li {
            position: relative;
            width: 50%;
            height: 124px;
            padding: 20px 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #EEEEEE;
            border-radius: 10px;
            cursor: pointer;
            font-size: 14px;
            color: #333;
            font-weight: bold;
            font-family: PingFangSC, PingFang SC;
            span {
                position: absolute;
                left: 0;
                top: -5px;
                font-size: 10px;
                background: #f65959;
                color: #fff;
                padding: 2px 7px;
                border-radius: 7px 0 7px 0;
            }
            .price {
                color: #6D4008;
                font-size: 30px;
                line-height: 37px;
                margin: 4px 0 8px 0;
                font-family: PingFangSC, PingFang SC;
            }
            .old-price {
                color: #888888;
                text-decoration: line-through;
                font-size: 12px;
                font-weight: 400;
                font-family: PingFangSC, PingFang SC;
            }
        }
        li.active {
            height: 124px;
            background: #FEF7F1;
            border-radius: 10px;
            border: 1px solid #F8BA68;
        }
    }
    .vip-block {
        padding: 0 17px;
        ul {
            flex: 1;
            display: flex;
            gap: 20px 5%;
            flex-wrap: wrap;
        }
        li {
            width: 30%;
            text-align: center;
            color: #333;
            font-size: 14px;
            padding: 0 3px;
            img {
                width: 44px;
                height: 44px;
                margin-bottom: 6px;
            }
        }
    }
    .equity-block {
        padding: 0 17px;
        margin: 17px 0 34px 0;
        ul {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
        }
        li {
            width: 24%;
            text-align: center;
            color: #333;
            font-weight: 500;
            font-size: 14px;
            padding: 10px 3px;
            font-family: PingFang-SC, PingFang-SC;
            box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
            img {
                width: 14px;
                vertical-align: middle;
            }
            div {
                height: 30px;
                line-height: 30px;
            }
            div:nth-child(2) {
                font-size: 14px;
                font-weight: 800;
            }
            p {
                font-family: PingFang-SC, PingFang-SC;
            }
        }
        li:first-child {
            width: 28%;
        }
        .level-icon {
            width: 32px;
            height: 28px;
            display: inline-block;
        }
        i.level-icon {
            display: block;
        }
        .equity0 {
            font-size: 12px;
            color: #888;
            font-weight: 400;
            border-radius: 10px 0px 0px 10px;
        }
        .equity1 {
            background-color: #FAE7CB;
        }
        .equity2 {
            background-color: #ECECEC;
        }
        .equity3 {
            background-color: #ddddf2;
        }
        .l0e3,.l1e2,.l2e1{
            transform: scale(1.08) translate(0, 8px);
            border-radius: 10px;
            padding-bottom: 10px;
            .level-icon {
                margin-top: -30px;
                width: 44px;
                height: 39px;
            }
        }
    }
    button {
        width: -webkit-fill-available;
        height: 40px;
        background: #F8B966!important;
        border-radius: 10px;
        margin: 16px;
        font-weight: bold;
        color: #744919;
    }
    button:disabled {
        background-color: #f8b96675!important;
        color: #fff;
    }
    
    .protocal-block {
        margin: 16px 16px 0;
        display: flex;
        .protocal-text {
            flex: 1;
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #888888;
            line-height: 20px;
            i {
                float: right;
                font-size: 12px;
                font-weight: bold;
                line-height: 20px;
            }

        }
        
    }
}
.level-bg1 {
    background: url(../../assets/h5/level-bg1.png); 
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.level-bg2 {
    background: url(../../assets/h5/level-bg2.png); 
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.level-bg3 {
    background: url(../../assets/h5/level-bg3.png); 
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.el-drawer__header {
    margin: 0;
    padding: 0;
}
</style>
